import themesConfig from 'app/configs/themesConfig';
import _ from 'lodash';

import {
  defaultThemeOptions,
  deprecatedThemesConfig,
  mustHaveThemeOptions,
  ThemeMode,
} from 'constants/themes';

export const checkIsDarkTheme = themeType => themeType === ThemeMode.DARK;
export const checkIsLightTheme = themeType => themeType === ThemeMode.LIGHT;

const getThemeMixins = theme => ({
  border: (width = 1) => ({
    borderWidth: width,
    borderStyle: 'solid',
    borderColor: theme.palette.divider,
  }),
  borderLeft: (width = 1) => ({
    borderLeftWidth: width,
    borderStyle: 'solid',
    borderColor: theme.palette.divider,
  }),
  borderRight: (width = 1) => ({
    borderRightWidth: width,
    borderStyle: 'solid',
    borderColor: theme.palette.divider,
  }),
  borderTop: (width = 1) => ({
    borderTopWidth: width,
    borderStyle: 'solid',
    borderColor: theme.palette.divider,
  }),
  borderBottom: (width = 1) => ({
    borderBottomWidth: width,
    borderStyle: 'solid',
    borderColor: theme.palette.divider,
  }),
});

export const getExtendedThemesConfigs = () => {
  const extendedThemes = Object.entries(_.merge({}, deprecatedThemesConfig, themesConfig)).reduce(
    (acc, [themeKey, themeConfig]) => {
      const mergedTheme = _.merge({}, mustHaveThemeOptions, defaultThemeOptions, themeConfig);
      const extendedThemeWithMixins = _.merge(mergedTheme, { mixins: getThemeMixins(mergedTheme) });

      acc[themeKey] = extendedThemeWithMixins;

      return acc;
    },
    {},
  );

  return extendedThemes;
};
